import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { dictionary } from '../lib/content';
export function Timeline() {
  const {
    lang,
    t
  } = useI18n();
  const items = dictionary[lang].timeline.items;
  return <section className="w-full bg-white py-32 px-6 md:px-12 border-t border-black/[0.06]" data-id="element-202" data-mp="2s48qo5kzm8nk">
      <div className="max-w-5xl mx-auto" data-id="element-203" data-mp="2w4j9wjxsivkd">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-5xl text-[#0A0A0F] mb-20 tracking-tight" data-id="element-204" data-mp="2i6b73ve2p01a">
          {t('timeline.title')}
        </motion.h2>

        <div className="relative" data-id="element-205" data-mp="7cfc7mtf4a0e">
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-black/[0.08]" aria-hidden="true" data-id="element-206" data-mp="bg4y24ipkdhq" />

          <ul className="space-y-16" data-id="element-207" data-mp="2n5eefri39ids">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: i * 0.05
          }} className={`relative pl-10 md:pl-0 md:grid md:grid-cols-2 md:gap-12 ${i % 2 === 0 ? '' : 'md:[&>div:first-child]:col-start-2'}`} data-id="element-208" data-mp="2i7cw58shln3d" data-mpi={i}>
                <div className={i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12'} data-id="element-209" data-mp="3ploe1sah2myb">
                  <div className="text-xs font-mono tracking-widest text-violet-electric mb-2" data-id="element-210" data-mp="3km3ebfnhaakj">
                    {item.year}
                  </div>
                  <h3 className="text-xl text-[#0A0A0F] font-medium mb-2" data-id="element-211" data-mp="iz4mxrlv0dp">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#4A4A55] leading-relaxed" data-id="element-212" data-mp="5jwm184sjqe5">
                    {item.desc}
                  </p>
                </div>
                <span className="absolute left-0 md:left-1/2 top-1 w-2.5 h-2.5 -translate-x-1/2 rounded-full bg-violet-electric ring-4 ring-violet-100" aria-hidden="true" data-id="element-213" data-mp="38zbsjzdynhuj" />
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}